import React from "react"

import { Popup } from "@shared/components"
import { useRandomPopup } from "@shared/hooks"

export default function RandomPopup() {
  const [popup, setPopup] = useRandomPopup("LIVE")

  if (!popup) {
    return null
  }

  return <Popup popup={popup} handlePopup={setPopup} />
}
